export const formatNumber = (num, ignoreThousand) => {
	if (!num) {
		return 0
	}
	// if number is greater than 1000000, format it to 1M
	if (num > 1000000) {
		return `${Math.round(num / 1000000)}M`
	}
	//if number is greater than 1000, format it to 1k
	if (num > 1000 && !ignoreThousand) {
		return `${Math.round(num / 1000)}k`
	} else if (ignoreThousand) {
		return num?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
	}

	return num
}
